import { NormalizedCacheObject } from 'apollo-boost';

import { Product } from '../typings/products';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';
import { DNAApolloClient } from './DNAApolloClient/DNAApolloClient';
import { RestApiManager } from './RestApiManager';

export class ProductsDataProvider extends BaseDataProvider {
    private apiManager: RestApiManager;

    constructor(apiManager: RestApiManager, client: DNAApolloClient<NormalizedCacheObject>) {
        super(client);
        this.apiManager = apiManager;
    }

    public getList() {
        return this.apiManager.getInternalProducts();
    }

    public getPlaces() {
        return this.apiManager.getInternalProductPlaces();
    }

    public createProduct(name: string, description: string) {
        return this.apiManager.createInternalProduct(name, description);
    }

    public updateDescription(product: Product) {
        return this.apiManager.updateInternalProductDescription(Number(product.id), product.description);
    }
}
